import React from 'react';

const TableTD = ({ field, iseditable, iseditableid, editData, setEditData, item, handeleditbutton, clickable, selectedid, setIseditable, setIseditableid, batchaddition }) => {
    
    return (
        <td className={clickable?.[field]?.[item._id]}>
            <div className="input-group text-center d-flex justify-content-center flex-nowrap">
                {iseditableid === "batch" && editData[iseditable] > 0 && iseditable.slice(0, -5) === field && selectedid.includes(item._id) ? (
                    batchaddition ? (
                        <div className="d-flex justify-content-center align-items-center fw-normal small">
                            <span>{Number(item[field])}</span>
                            <span className="fw-bold ms-1" style={{ color: 'darkgreen' }}>
                                + {Number((editData[iseditable] / selectedid.length).toFixed(1))}
                            </span>
                        </div>
                    ) : (
                        <div className="d-flex justify-content-center align-items-center fw-normal">
                            <span className="fw-bold ms-1" style={{ color: 'darkgreen' }}>
                                {Number((editData[iseditable])).toFixed(1)}
                            </span>
                        </div>
                    )
                ) : (
                    <input
                        type={iseditableid === "batch" ? "text" : "number"}
                        /* Fixed: font-size 16px is MANDATORY for iOS to prevent zoom-glitch */
                        /* Added touch-action to improve tap responsiveness */
                        style={{ fontSize: '16px', touchAction: 'manipulation', minWidth: '60px' }}
                        className='form-control centerplaceholder no-spinner px-1'
                        aria-label={field}
                        placeholder={field}
                        value={iseditable === field && iseditableid === item._id ? editData[field] : (item[field] || 0)}
                        // readOnly={iseditable !== field && iseditableid !== item._id}
                        onClick={() => handeleditbutton(field, item, "inpt")}
                        /* Fixed: iOS Blur logic - use relatedTarget to see if we clicked the check button */
                        onBlur={(e) => {
                            if (!e.relatedTarget || !e.relatedTarget.classList.contains('checkbtn')) {
                                setTimeout(() => {
                                    setIseditable("");
                                    setIseditableid("");
                                }, 250);
                            }
                        }}
                        onChange={(e) => { setEditData({ ...editData, [field]: e.target.value }) }}
                    />
                )}
                {iseditable === field && iseditableid === item._id && (
                    <button
                        className="btn btn-outline-secondary checkbtn px-2"
                        type="button"
                        /* Important: relatedTarget check above depends on this button being focusable */
                        tabIndex="-1" 
                        onClick={() => handeleditbutton(field, item, "btn")}
                    >
                        <i className="bi bi-check-lg"></i>
                    </button>
                )}
            </div>
        </td>
    );
}

export default TableTD;